__turbopack_context__.v({
  "button": "AVideo-module-scss-module__M0d1GW__button",
  "image": "AVideo-module-scss-module__M0d1GW__image",
  "image-is-background": "AVideo-module-scss-module__M0d1GW__image-is-background",
  "placeholder": "AVideo-module-scss-module__M0d1GW__placeholder",
  "video": "AVideo-module-scss-module__M0d1GW__video",
  "video-is-background": "AVideo-module-scss-module__M0d1GW__video-is-background",
  "video-is-visible": "AVideo-module-scss-module__M0d1GW__video-is-visible",
});
